var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirefoxIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2619 6.70405C17.8813 5.78587 17.1099 4.79462 16.5043 4.4815C16.9972 5.4501 17.2823 6.42162 17.3913 7.14652C17.3913 7.14652 17.3913 7.15163 17.3932 7.16113C16.4026 4.6861 14.7227 3.68791 13.3508 1.51504C13.2812 1.40543 13.2119 1.29582 13.1441 1.17854C13.1058 1.1124 13.0748 1.05248 13.0478 0.995851C12.991 0.885984 12.9471 0.76987 12.917 0.649844C12.9172 0.644144 12.9153 0.638558 12.9117 0.63417C12.908 0.629782 12.9029 0.626904 12.8973 0.626094C12.8919 0.624635 12.8862 0.624635 12.8809 0.626094C12.8794 0.626756 12.8781 0.627617 12.8769 0.628652C12.8747 0.628652 12.8725 0.63121 12.8703 0.63194L12.8739 0.627191C10.673 1.91914 9.92638 4.30904 9.85784 5.5049C8.97835 5.56518 8.1374 5.88974 7.44474 6.43623C7.37234 6.37488 7.29664 6.31755 7.21798 6.26451C7.01836 5.56419 7.00993 4.82302 7.19355 4.11832C6.29342 4.52936 5.59345 5.17789 5.0845 5.75189H5.08049C4.73306 5.31089 4.75748 3.85634 4.77717 3.55272C4.77316 3.53372 4.51833 3.68535 4.48551 3.70837C4.17893 3.92756 3.89235 4.17357 3.62913 4.4435C3.3296 4.74784 3.05595 5.07672 2.81104 5.42671C2.24755 6.22702 1.84794 7.13132 1.63529 8.08735C1.63128 8.10635 1.62764 8.12608 1.62363 8.14544C1.60722 8.22254 1.5478 8.60946 1.53722 8.6935V8.71286C1.45975 9.11266 1.4115 9.5176 1.39285 9.92444V9.96938C1.39285 14.8186 5.31564 18.75 10.1542 18.75C14.4879 18.75 18.0859 15.5968 18.7906 11.455C18.8052 11.3428 18.8172 11.2295 18.8303 11.1163C19.0046 9.61022 18.811 8.02743 18.2619 6.70405ZM8.16331 13.5774C8.20414 13.5968 8.24279 13.6183 8.28471 13.6373L8.29055 13.641C8.24862 13.6205 8.20597 13.5993 8.16368 13.5774H8.16331ZM17.3939 7.16515V7.15675V7.16625V7.16515Z",
    fill: "url(#paint0_linear_8496_110948)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2619 6.704C17.8813 5.78582 17.1099 4.79457 16.5043 4.48145C16.9972 5.45005 17.2823 6.42157 17.3913 7.14647V7.16437C18.2182 9.41067 17.7676 11.695 17.1186 13.0907C16.1146 15.25 13.684 17.4635 9.87896 17.3557C5.77133 17.2388 2.15004 14.1802 1.47376 10.1776C1.35054 9.54586 1.47376 9.22543 1.53574 8.71281C1.46027 9.10778 1.43147 9.22214 1.39392 9.92439V9.96933C1.39392 14.8185 5.31671 18.7499 10.1553 18.7499C14.489 18.7499 18.0869 15.5968 18.7916 11.4549C18.8062 11.3428 18.8183 11.2295 18.8314 11.1162C19.0046 9.61017 18.811 8.02738 18.2619 6.704Z",
    fill: "url(#paint1_radial_8496_110948)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2619 6.704C17.8813 5.78582 17.1099 4.79457 16.5043 4.48145C16.9972 5.45005 17.2823 6.42157 17.3913 7.14647V7.16437C18.2182 9.41067 17.7676 11.695 17.1186 13.0907C16.1146 15.25 13.684 17.4635 9.87896 17.3557C5.77133 17.2388 2.15004 14.1802 1.47376 10.1776C1.35054 9.54586 1.47376 9.22543 1.53574 8.71281C1.46027 9.10778 1.43147 9.22214 1.39392 9.92439V9.96933C1.39392 14.8185 5.31671 18.7499 10.1553 18.7499C14.489 18.7499 18.0869 15.5968 18.7916 11.4549C18.8062 11.3428 18.8183 11.2295 18.8314 11.1162C19.0046 9.61017 18.811 8.02738 18.2619 6.704Z",
    fill: "url(#paint2_radial_8496_110948)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0041 7.73587C14.0235 7.74939 14.0406 7.7629 14.0588 7.77642C13.8389 7.38513 13.565 7.02694 13.2451 6.71246C10.5218 3.98314 12.5313 0.794172 12.87 0.631947L12.8736 0.627197C10.6727 1.91915 9.92605 4.30905 9.85751 5.50491C9.95959 5.49797 10.0613 5.4892 10.1652 5.4892C11.8076 5.4892 13.2382 6.39459 14.0041 7.73587Z",
    fill: "url(#paint3_radial_8496_110948)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1707 8.28094C10.1565 8.50016 9.38648 9.25283 9.11706 9.25283C6.62558 9.25283 6.22127 10.7633 6.22127 10.7633C6.33064 12.0355 7.21509 13.083 8.28511 13.6373C8.33396 13.6625 8.38318 13.6851 8.43094 13.7078C8.51661 13.7443 8.60265 13.7809 8.68832 13.8134C9.05528 13.9431 9.43954 14.017 9.82834 14.0326C14.1952 14.238 15.0417 8.79976 11.89 7.22063C12.6968 7.07996 13.5346 7.40551 14.0023 7.73471C13.2367 6.39343 11.8058 5.48804 10.1634 5.48804C10.0595 5.48804 9.95776 5.49681 9.85568 5.50375C8.97683 5.56477 8.13669 5.8897 7.44477 6.43618C7.57857 6.54981 7.7295 6.70107 8.04704 7.01456C8.64275 7.60354 10.1674 8.20969 10.1707 8.28094Z",
    fill: "url(#paint4_radial_8496_110948)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1707 8.28094C10.1565 8.50016 9.38648 9.25283 9.11706 9.25283C6.62558 9.25283 6.22127 10.7633 6.22127 10.7633C6.33064 12.0355 7.21509 13.083 8.28511 13.6373C8.33396 13.6625 8.38318 13.6851 8.43094 13.7078C8.51661 13.7443 8.60265 13.7809 8.68832 13.8134C9.05528 13.9431 9.43954 14.017 9.82834 14.0326C14.1952 14.238 15.0417 8.79976 11.89 7.22063C12.6968 7.07996 13.5346 7.40551 14.0023 7.73471C13.2367 6.39343 11.8058 5.48804 10.1634 5.48804C10.0595 5.48804 9.95776 5.49681 9.85568 5.50375C8.97683 5.56477 8.13669 5.8897 7.44477 6.43618C7.57857 6.54981 7.7295 6.70107 8.04704 7.01456C8.64275 7.60354 10.1674 8.20969 10.1707 8.28094Z",
    fill: "url(#paint5_radial_8496_110948)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03751 6.14439C7.1086 6.19043 7.16693 6.22916 7.21979 6.2646C7.02018 5.56428 7.01174 4.82311 7.19537 4.11841C6.29524 4.52945 5.59526 5.17799 5.08632 5.75198C5.12752 5.75089 6.39841 5.72787 7.03751 6.14439Z",
    fill: "url(#paint6_radial_8496_110948)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47399 10.1776C2.15027 14.1802 5.77156 17.2388 9.88211 17.3557C13.6871 17.4635 16.1163 15.25 17.1218 13.0907C17.7707 11.6946 18.2213 9.41068 17.3945 7.16437V7.14756C17.3945 7.14976 17.3945 7.15268 17.3963 7.16218C17.7069 9.1962 16.6748 11.1667 15.0612 12.4992C15.0595 12.5029 15.058 12.5067 15.0565 12.5105C11.912 15.0765 8.90323 14.0586 8.29403 13.6431C8.25174 13.6227 8.20909 13.6015 8.1668 13.5796C6.33337 12.7027 5.57615 11.0274 5.73839 9.5919C4.19078 9.5919 3.66288 8.28314 3.66288 8.28314C3.66288 8.28314 5.05263 7.29006 6.88423 8.1538C8.58059 8.95396 10.1738 8.2835 10.1738 8.28314C10.1705 8.21189 8.64584 7.60391 8.05123 7.01676C7.73369 6.70327 7.58275 6.55201 7.44896 6.43838C7.37656 6.37702 7.30086 6.3197 7.22219 6.26665C7.17006 6.23012 7.11282 6.19358 7.03991 6.14645C6.40081 5.72992 5.12992 5.75294 5.08799 5.75404H5.08398C4.73654 5.31303 4.76097 3.85849 4.78066 3.55487C4.77665 3.53587 4.52181 3.68749 4.489 3.71051C4.18242 3.92971 3.89584 4.17571 3.63262 4.44564C3.33309 4.74999 3.05944 5.07887 2.81452 5.42886C2.25104 6.22916 1.85143 7.13347 1.63878 8.08949C1.63185 8.1063 1.32014 9.47023 1.47399 10.1776Z",
    fill: "url(#paint7_radial_8496_110948)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2451 6.71246C13.565 7.02693 13.8389 7.38513 14.0588 7.77642C14.1044 7.81071 14.1482 7.8473 14.19 7.88603C16.1762 9.71873 15.1372 12.3132 15.0581 12.4996C16.6717 11.1671 17.7038 9.19662 17.3932 7.16259C16.4026 4.6861 14.7227 3.68791 13.3508 1.51504C13.2812 1.40543 13.2119 1.29582 13.1441 1.17854C13.1058 1.1124 13.0748 1.05248 13.0478 0.995851C12.991 0.885984 12.9471 0.76987 12.917 0.649844C12.9172 0.644144 12.9153 0.638559 12.9117 0.63417C12.908 0.629782 12.9029 0.626904 12.8973 0.626094C12.8919 0.624635 12.8862 0.624635 12.8809 0.626094C12.8794 0.626756 12.8781 0.627617 12.8768 0.628652C12.8747 0.628652 12.8725 0.63121 12.8703 0.63194C12.5312 0.794165 10.5217 3.98313 13.2451 6.71246Z",
    fill: "url(#paint8_radial_8496_110948)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1893 7.88413C14.1474 7.8454 14.1036 7.80882 14.0581 7.77452C14.0402 7.761 14.0216 7.74748 14.0034 7.73396C13.5356 7.40513 12.6979 7.07922 11.8911 7.21989C15.0424 8.79902 14.1962 14.2372 9.82941 14.0319C9.44062 14.0163 9.05635 13.9424 8.6894 13.8127C8.60372 13.7805 8.51769 13.7451 8.43201 13.7071C8.38243 13.6844 8.33321 13.6618 8.28618 13.6365L8.29202 13.6402C8.90121 14.0567 11.91 15.0746 15.0544 12.5075C15.0544 12.5075 15.0563 12.5028 15.0592 12.4962C15.1372 12.3132 16.1762 9.71866 14.1893 7.88413Z",
    fill: "url(#paint9_radial_8496_110948)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2212 10.7633C6.2212 10.7633 6.62551 9.25281 9.11699 9.25281C9.38641 9.25281 10.1564 8.49942 10.1706 8.28092C10.1848 8.06243 8.57742 8.95175 6.88107 8.15158C5.04946 7.28784 3.65972 8.28092 3.65972 8.28092C3.65972 8.28092 4.18762 9.58969 5.73522 9.58969C5.57299 11.0252 6.3302 12.699 8.16363 13.5774C8.20447 13.5967 8.24311 13.6183 8.28504 13.6373C7.21502 13.0841 6.33166 12.0355 6.2212 10.7633Z",
    fill: "url(#paint10_radial_8496_110948)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2619 6.70405C17.8813 5.78587 17.1099 4.79462 16.5043 4.4815C16.9972 5.4501 17.2823 6.42162 17.3913 7.14652C17.3913 7.14652 17.3913 7.15163 17.3932 7.16113C16.4026 4.6861 14.7227 3.68791 13.3508 1.51504C13.2812 1.40543 13.2119 1.29582 13.1441 1.17854C13.1058 1.1124 13.0748 1.05248 13.0478 0.995851C12.991 0.885984 12.9471 0.76987 12.917 0.649844C12.9172 0.644144 12.9153 0.638558 12.9117 0.63417C12.908 0.629782 12.9029 0.626904 12.8973 0.626094C12.8919 0.624635 12.8862 0.624635 12.8809 0.626094C12.8794 0.626756 12.8781 0.627617 12.8769 0.628652C12.8747 0.628652 12.8725 0.63121 12.8703 0.63194L12.8739 0.627191C10.673 1.91914 9.92638 4.30904 9.85784 5.5049C9.95992 5.49796 10.0616 5.48919 10.1655 5.48919C11.8079 5.48919 13.2385 6.39458 14.0045 7.73586C13.5367 7.40703 12.6989 7.08111 11.8921 7.22178C15.0435 8.80092 14.1973 14.2391 9.8305 14.0338C9.4417 14.0182 9.05743 13.9443 8.69048 13.8145C8.60481 13.7824 8.51877 13.747 8.43309 13.709C8.38351 13.6863 8.3343 13.6636 8.28727 13.6384L8.2931 13.6421C8.25081 13.6216 8.20815 13.6004 8.16586 13.5785C8.2067 13.5979 8.24534 13.6194 8.28727 13.6384C7.21506 13.0842 6.3317 12.0356 6.22124 10.7633C6.22124 10.7633 6.62555 9.25288 9.11703 9.25288C9.38645 9.25288 10.1564 8.49949 10.1706 8.28099C10.1674 8.20975 8.64272 7.60177 8.04811 7.01462C7.73057 6.70113 7.57963 6.54986 7.44583 6.43623C7.37344 6.37488 7.29774 6.31755 7.21907 6.26451C7.01946 5.56419 7.01102 4.82302 7.19464 4.11832C6.29452 4.52936 5.59454 5.17789 5.0856 5.75189H5.08159C4.73415 5.31089 4.75858 3.85634 4.77826 3.55272C4.77425 3.53372 4.51942 3.68535 4.48661 3.70837C4.18003 3.92756 3.89345 4.17357 3.63023 4.4435C3.3307 4.74784 3.05705 5.07672 2.81213 5.42671C2.24865 6.22702 1.84903 7.13132 1.63639 8.08735C1.63238 8.10635 1.62873 8.12608 1.62472 8.14544C1.60831 8.22254 1.53394 8.61494 1.52373 8.69898C1.52373 8.69277 1.52373 8.70556 1.52373 8.69898C1.45547 9.10444 1.41176 9.51368 1.39285 9.92444V9.96938C1.39285 14.8186 5.31564 18.75 10.1542 18.75C14.4879 18.75 18.0859 15.5968 18.7906 11.455C18.8052 11.3428 18.8172 11.2295 18.8303 11.1163C19.0046 9.61022 18.811 8.02743 18.2619 6.70405ZM17.3928 7.15492V7.16442V7.15492Z",
    fill: "url(#paint11_linear_8496_110948)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8496_110948",
    x1: 17.1022,
    y1: 3.43288,
    x2: 2.52655,
    y2: 17.4648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8496_110948",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4299 2.63668) scale(18.2654 18.3055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8496_110948",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.75573 10.1202) scale(18.2654 18.3055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DB293D",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F5334B",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_8496_110948",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9582 -1.51753) scale(13.2325 13.2615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_8496_110948",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.7357 14.9018) scale(8.69686 8.71594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_8496_110948",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0181 7.94467) rotate(-13.9265) scale(4.60823 5.42407)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8C4FF3",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_8496_110948",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.52498 1.88781) scale(6.25678 6.27051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_8496_110948",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4433 -2.08939) scale(26.6943 26.7529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_8496_110948",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8627 0.833589) rotate(84.2447) scale(19.4998 12.7839)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_8496_110948",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.37771 4.20996) scale(16.6653 16.7019)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_8496_110948",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7769 5.18769) scale(18.2402 18.2803)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8496_110948",
    x1: 16.9272,
    y1: 3.35761,
    x2: 4.52437,
    y2: 15.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FFF44F",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFF44F",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefoxIcon);
export default __webpack_public_path__ + "static/media/firefox-icon.20b23e36d55655c4027997f5a236a4cc.svg";
export { ForwardRef as ReactComponent };